.fieldLabel {
    display: flex;
    gap: 10px;
}